module.exports = __webpack_public_path__ + "img/suivi-cycle-menstruel-regles-moonly-app.b7a81a93.svg";